import EyeIcon from '@/components/_common/EyeIcon';
import { WorkOrderItemType } from '@/core/domain/workorder/WorkOrdersItems/WorkOrdersItems.types';
import { WorkOrderItemData } from '..';
import { useDisclosure } from '@/hooks';
import WorkOrderItemViewModal from '../../WorkOrderItemViewModal';
import { useWorkorderDetailContext } from '../../../WorkorderDetailProvider';
import { WorkOrderComplementStatus } from '@/core/domain/workorder/WorkOrdersComplements/WorkOrdersComplements.types';
import { Divider } from 'antd';

interface Props {
  workOrderItem: WorkOrderItemData;
}

export default function WorkOrderItemDetail(props: Props) {
  const { workOrderItem } = props;

  const [modalOpened, modalAction] = useDisclosure();

  const {
    complement: { data: complement },
  } = useWorkorderDetailContext();

  const isClosed = complement?.status === WorkOrderComplementStatus.Closed;
  const isCancelled =
    complement?.status === WorkOrderComplementStatus.Cancelled;

  if (!isClosed && !isCancelled) return null;

  return (
    <>
      <Divider type="vertical" />

      <EyeIcon
        disabled={
          workOrderItem.type === WorkOrderItemType.Kit ||
          workOrderItem.type === WorkOrderItemType.Benefit ||
          workOrderItem.type === WorkOrderItemType.Bosch
        }
        iconProps={{
          onClick: modalAction.open,
        }}
      />

      <WorkOrderItemViewModal
        open={modalOpened}
        onCancel={modalAction.close}
        workorderItem={workOrderItem}
      />
    </>
  );
}
